import CurrencyInput from './CurrencyInput'

export default CurrencyInput
